import Reveal from "@/components/escape21/Reveal";
import CountUp from "@/components/escape21/CountUp";
import { GENERAL_PRINTS } from "./constants";

const Metrics = () => (
  <section id="metrics" className="px-6 py-20 sm:py-28">
    <div className="mx-auto max-w-5xl">
      <Reveal className="text-center">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
          impacto em números
        </span>
        <h2 className="mx-auto mt-4 max-w-2xl text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          o crescimento não é <span className="e21-serif text-green-400">promessa</span>. é print.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/55 sm:text-lg">
          dobrei de seguidores nas últimas semanas e abri uma frente nova no tiktok.
          zero tráfego pago em tudo isso.
        </p>
      </Reveal>

      {/* cards de números */}
      <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Reveal className="rounded-2xl border border-white/10 bg-white/5 p-6 text-center">
          <div className="text-4xl font-extrabold tracking-[-0.03em] text-green-400 sm:text-5xl">
            ~<CountUp end={40} className="tabular-nums" />
            <span className="text-2xl sm:text-3xl"> mil</span>
          </div>
          <p className="mt-2 text-sm text-white/60">seguidores no instagram</p>
        </Reveal>

        <Reveal delay={80} className="rounded-2xl border border-white/10 bg-white/5 p-6 text-center">
          <div className="text-4xl font-extrabold tracking-[-0.03em] text-green-400 sm:text-5xl">
            <CountUp end={15} className="tabular-nums" />
            <span className="text-2xl sm:text-3xl"> mil</span>
          </div>
          <p className="mt-2 text-sm text-white/60">no tiktok em 3 semanas</p>
        </Reveal>

        <Reveal delay={160} className="rounded-2xl border border-white/10 bg-white/5 p-6 text-center">
          <div className="text-4xl font-extrabold tracking-[-0.03em] text-green-400 sm:text-5xl">
            3 · 5 · <span className="e21-serif">8M</span>
          </div>
          <p className="mt-2 text-sm text-white/60">views nos vídeos que estouraram</p>
        </Reveal>

        <Reveal delay={240} className="rounded-2xl border border-white/10 bg-white/5 p-6 text-center">
          <div className="text-4xl font-extrabold tracking-[-0.03em] text-green-400 sm:text-5xl">
            <CountUp end={1700} className="tabular-nums" />
          </div>
          <p className="mt-2 text-sm text-white/60">na lista de espera em 1 semana, 100% orgânico</p>
        </Reveal>
      </div>

      <Reveal delay={120} className="mt-8 text-center">
        <p className="text-base text-white/55 sm:text-lg">
          no formato falado, cada vídeo faz de{" "}
          <span className="font-bold text-white">100 mil a 1 milhão</span> de views.
        </p>
      </Reveal>

      {/* faixa de prova visual: prints reais dos insights */}
      <Reveal delay={160} className="mt-14">
        <p className="mb-5 text-center font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
          os prints, sem retoque
        </p>
        <div className="e21-no-scrollbar -mx-6 flex snap-x snap-mandatory items-start gap-4 overflow-x-auto px-6 sm:px-8">
          {GENERAL_PRINTS.map(({ src, label }, i) => (
            <figure key={src} className="flex-none snap-center">
              <img
                src={src}
                alt={label}
                loading="lazy"
                className={`max-h-[320px] w-auto max-w-[80vw] rounded-2xl border border-white/10 bg-white/5 shadow-sm transition-transform duration-300 hover:scale-[1.03] sm:max-h-[360px] ${
                  i % 2 === 0 ? "rotate-1" : "-rotate-1"
                } hover:rotate-0`}
              />
              <figcaption className="mt-2 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-white/35">
                {label}
              </figcaption>
            </figure>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default Metrics;
